module.exports = __webpack_public_path__ + "static/media/Folders3.783e9bb6.svg";